import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
  NbMenuModule,
  NbSidebarModule,
  NbTreeGridModule,
  NbInputModule,
  NbSpinnerModule,
  NbCheckboxModule,
} from '../../common/public_api';

import { NgxCommonModule } from '../../common/ngx-common.module';
import { RouterModule } from '@angular/router';
import { PostsComponent } from './posts.component';

@NgModule({
  imports: [
    NgxCommonModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    NbTreeGridModule,
    NbProgressBarModule,
    NbMenuModule,
    NbSidebarModule,
    RouterModule,
    NbInputModule,
    NbSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NbCheckboxModule,
  ],
  declarations: [
    PostsComponent,
  ],
  providers: [],
})
export class PostsModule { }
